import { createContext, useContext } from "react";
import type { useBatchJobs } from "./useBatchJobs";

export type BatchJobsApi = ReturnType<typeof useBatchJobs>;

export const BatchJobsContext = createContext<BatchJobsApi | null>(null);

/** Access the shared batch-jobs state. Must be used within BatchJobsProvider. */
export const useSharedBatchJobs = (): BatchJobsApi => {
  const ctx = useContext(BatchJobsContext);
  if (!ctx) {
    throw new Error("useSharedBatchJobs must be used within a BatchJobsProvider");
  }
  return ctx;
};
